const data = [
  {
    "season": "2022",
    "round": "1",
    "raceName": "Bahrain Grand Prix",
    "raceCode": "BHR",
    "date": "2022-03-20",
    "circuitName": "Bahrain International Circuit",
    "locality": "Sakhir",
    "country": "Bahrain",
    "Leclerc": 1,
    "Sainz": 2,
    "Hamilton": 3,
    "Russell": 4,
    "Magnussen": 5,
    "Bottas": 6,
    "Ocon": 7,
    "Tsunoda": 8,
    "Alonso": 9,
    "Zhou": 10,
    "Schumacher": 11,
    "Stroll": 12,
    "Albon": 13,
    "Ricciardo": 14,
    "Norris": 15,
    "Latifi": 16,
    "Hülkenberg": 17,
    "Pérez": 18,
    "Verstappen": 19,
    "Gasly": 20
  },
  {
    "season": "2022",
    "round": "2",
    "raceName": "Saudi Arabian Grand Prix",
    "raceCode": "SAU",
    "date": "2022-03-27",
    "circuitName": "Jeddah Corniche Circuit",
    "locality": "Jeddah",
    "country": "Saudi Arabia",
    "Verstappen": 1,
    "Leclerc": 2,
    "Sainz": 3,
    "Pérez": 4,
    "Russell": 5,
    "Ocon": 6,
    "Norris": 7,
    "Gasly": 8,
    "Magnussen": 9,
    "Hamilton": 10,
    "Zhou": 11,
    "Hülkenberg": 12,
    "Stroll": 13,
    "Albon": 14,
    "Bottas": 15,
    "Alonso": 16,
    "Ricciardo": 17,
    "Latifi": 18,
    "Tsunoda": 19,
    "Schumacher": 20
  },
  {
    "season": "2022",
    "round": "3",
    "raceName": "Australian Grand Prix",
    "raceCode": "AUS",
    "date": "2022-04-10",
    "circuitName": "Albert Park Grand Prix Circuit",
    "locality": "Melbourne",
    "country": "Australia",
    "Leclerc": 1,
    "Pérez": 2,
    "Russell": 3,
    "Hamilton": 4,
    "Norris": 5,
    "Ricciardo": 6,
    "Ocon": 7,
    "Bottas": 8,
    "Gasly": 9,
    "Albon": 10,
    "Zhou": 11,
    "Stroll": 12,
    "Schumacher": 13,
    "Magnussen": 14,
    "Tsunoda": 15,
    "Latifi": 16,
    "Alonso": 17,
    "Verstappen": 18,
    "Vettel": 19,
    "Sainz": 20
  },
  {
    "season": "2022",
    "round": "4",
    "raceName": "Emilia Romagna Grand Prix",
    "raceCode": "EMR",
    "date": "2022-04-24",
    "circuitName": "Autodromo Enzo e Dino Ferrari",
    "locality": "Imola",
    "country": "Italy",
    "Verstappen": 1,
    "Pérez": 2,
    "Norris": 3,
    "Russell": 4,
    "Bottas": 5,
    "Leclerc": 6,
    "Tsunoda": 7,
    "Vettel": 8,
    "Magnussen": 9,
    "Stroll": 10,
    "Albon": 11,
    "Gasly": 12,
    "Hamilton": 13,
    "Ocon": 14,
    "Zhou": 15,
    "Latifi": 16,
    "Schumacher": 17,
    "Ricciardo": 18,
    "Alonso": 19,
    "Sainz": 20
  },
  {
    "season": "2022",
    "round": "5",
    "raceName": "Miami Grand Prix",
    "raceCode": "MIA",
    "date": "2022-05-08",
    "circuitName": "Miami International Autodrome",
    "locality": "Miami",
    "country": "USA",
    "Verstappen": 1,
    "Leclerc": 2,
    "Sainz": 3,
    "Pérez": 4,
    "Russell": 5,
    "Hamilton": 6,
    "Bottas": 7,
    "Ocon": 8,
    "Albon": 9,
    "Stroll": 10,
    "Alonso": 11,
    "Tsunoda": 12,
    "Ricciardo": 13,
    "Latifi": 14,
    "Schumacher": 15,
    "Magnussen": 16,
    "Vettel": 17,
    "Gasly": 18,
    "Norris": 19,
    "Zhou": 20
  },
  {
    "season": "2022",
    "round": "6",
    "raceName": "Spanish Grand Prix",
    "raceCode": "ESP",
    "date": "2022-05-22",
    "circuitName": "Circuit de Barcelona-Catalunya",
    "locality": "Montmeló",
    "country": "Spain",
    "Verstappen": 1,
    "Pérez": 2,
    "Russell": 3,
    "Sainz": 4,
    "Hamilton": 5,
    "Bottas": 6,
    "Ocon": 7,
    "Norris": 8,
    "Alonso": 9,
    "Tsunoda": 10,
    "Vettel": 11,
    "Ricciardo": 12,
    "Gasly": 13,
    "Schumacher": 14,
    "Stroll": 15,
    "Latifi": 16,
    "Magnussen": 17,
    "Albon": 18,
    "Zhou": 19,
    "Leclerc": 20
  },
  {
    "season": "2022",
    "round": "7",
    "raceName": "Monaco Grand Prix",
    "raceCode": "MCO",
    "date": "2022-05-29",
    "circuitName": "Circuit de Monaco",
    "locality": "Monte-Carlo",
    "country": "Monaco",
    "Pérez": 1,
    "Sainz": 2,
    "Verstappen": 3,
    "Leclerc": 4,
    "Russell": 5,
    "Norris": 6,
    "Alonso": 7,
    "Hamilton": 8,
    "Bottas": 9,
    "Vettel": 10,
    "Gasly": 11,
    "Ocon": 12,
    "Ricciardo": 13,
    "Stroll": 14,
    "Latifi": 15,
    "Zhou": 16,
    "Tsunoda": 17,
    "Albon": 18,
    "Schumacher": 19,
    "Magnussen": 20
  },
  {
    "season": "2022",
    "round": "8",
    "raceName": "Azerbaijan Grand Prix",
    "raceCode": "AZE",
    "date": "2022-06-12",
    "circuitName": "Baku City Circuit",
    "locality": "Baku",
    "country": "Azerbaijan",
    "Verstappen": 1,
    "Pérez": 2,
    "Russell": 3,
    "Hamilton": 4,
    "Gasly": 5,
    "Vettel": 6,
    "Alonso": 7,
    "Ricciardo": 8,
    "Norris": 9,
    "Ocon": 10,
    "Bottas": 11,
    "Albon": 12,
    "Tsunoda": 13,
    "Schumacher": 14,
    "Latifi": 15,
    "Stroll": 16,
    "Magnussen": 17,
    "Zhou": 18,
    "Leclerc": 19,
    "Sainz": 20
  },
  {
    "season": "2022",
    "round": "9",
    "raceName": "Canadian Grand Prix",
    "raceCode": "CAN",
    "date": "2022-06-19",
    "circuitName": "Circuit Gilles Villeneuve",
    "locality": "Montreal",
    "country": "Canada",
    "Verstappen": 1,
    "Sainz": 2,
    "Hamilton": 3,
    "Russell": 4,
    "Leclerc": 5,
    "Ocon": 6,
    "Bottas": 7,
    "Zhou": 8,
    "Alonso": 9,
    "Stroll": 10,
    "Ricciardo": 11,
    "Vettel": 12,
    "Albon": 13,
    "Gasly": 14,
    "Norris": 15,
    "Latifi": 16,
    "Magnussen": 17,
    "Tsunoda": 18,
    "Schumacher": 19,
    "Pérez": 20
  },
  {
    "season": "2022",
    "round": "10",
    "raceName": "British Grand Prix",
    "raceCode": "GBR",
    "date": "2022-07-03",
    "circuitName": "Silverstone Circuit",
    "locality": "Silverstone",
    "country": "UK",
    "Sainz": 1,
    "Pérez": 2,
    "Hamilton": 3,
    "Leclerc": 4,
    "Alonso": 5,
    "Norris": 6,
    "Verstappen": 7,
    "Schumacher": 8,
    "Vettel": 9,
    "Magnussen": 10,
    "Stroll": 11,
    "Latifi": 12,
    "Ricciardo": 13,
    "Tsunoda": 14,
    "Ocon": 15,
    "Gasly": 16,
    "Bottas": 17,
    "Russell": 18,
    "Zhou": 19,
    "Albon": 20
  },
  {
    "season": "2022",
    "round": "11",
    "raceName": "Austrian Grand Prix",
    "raceCode": "AUT",
    "date": "2022-07-10",
    "circuitName": "Red Bull Ring",
    "locality": "Spielberg",
    "country": "Austria",
    "Leclerc": 1,
    "Verstappen": 2,
    "Hamilton": 3,
    "Russell": 4,
    "Ocon": 5,
    "Schumacher": 6,
    "Norris": 7,
    "Magnussen": 8,
    "Ricciardo": 9,
    "Alonso": 10,
    "Bottas": 11,
    "Albon": 12,
    "Stroll": 13,
    "Zhou": 14,
    "Gasly": 15,
    "Tsunoda": 16,
    "Vettel": 17,
    "Sainz": 18,
    "Latifi": 19,
    "Pérez": 20
  },
  {
    "season": "2022",
    "round": "12",
    "raceName": "French Grand Prix",
    "raceCode": "FRA",
    "date": "2022-07-24",
    "circuitName": "Circuit Paul Ricard",
    "locality": "Le Castellet",
    "country": "France",
    "Verstappen": 1,
    "Hamilton": 2,
    "Russell": 3,
    "Pérez": 4,
    "Sainz": 5,
    "Alonso": 6,
    "Norris": 7,
    "Ocon": 8,
    "Ricciardo": 9,
    "Stroll": 10,
    "Vettel": 11,
    "Gasly": 12,
    "Albon": 13,
    "Bottas": 14,
    "Schumacher": 15,
    "Zhou": 16,
    "Latifi": 17,
    "Magnussen": 18,
    "Leclerc": 19,
    "Tsunoda": 20
  },
  {
    "season": "2022",
    "round": "13",
    "raceName": "Hungarian Grand Prix",
    "raceCode": "HUN",
    "date": "2022-07-31",
    "circuitName": "Hungaroring",
    "locality": "Budapest",
    "country": "Hungary",
    "Verstappen": 1,
    "Hamilton": 2,
    "Russell": 3,
    "Sainz": 4,
    "Pérez": 5,
    "Leclerc": 6,
    "Norris": 7,
    "Alonso": 8,
    "Ocon": 9,
    "Vettel": 10,
    "Stroll": 11,
    "Gasly": 12,
    "Zhou": 13,
    "Schumacher": 14,
    "Ricciardo": 15,
    "Magnussen": 16,
    "Albon": 17,
    "Latifi": 18,
    "Tsunoda": 19,
    "Bottas": 20
  },
  {
    "season": "2022",
    "round": "14",
    "raceName": "Belgian Grand Prix",
    "raceCode": "BEL",
    "date": "2022-08-28",
    "circuitName": "Circuit de Spa-Francorchamps",
    "locality": "Spa",
    "country": "Belgium",
    "Verstappen": 1,
    "Pérez": 2,
    "Sainz": 3,
    "Russell": 4,
    "Alonso": 5,
    "Leclerc": 6,
    "Ocon": 7,
    "Vettel": 8,
    "Gasly": 9,
    "Albon": 10,
    "Stroll": 11,
    "Norris": 12,
    "Tsunoda": 13,
    "Zhou": 14,
    "Ricciardo": 15,
    "Magnussen": 16,
    "Schumacher": 17,
    "Latifi": 18,
    "Bottas": 19,
    "Hamilton": 20
  },
  {
    "season": "2022",
    "round": "15",
    "raceName": "Dutch Grand Prix",
    "raceCode": "DEU",
    "date": "2022-09-04",
    "circuitName": "Circuit Park Zandvoort",
    "locality": "Zandvoort",
    "country": "Netherlands",
    "Verstappen": 1,
    "Russell": 2,
    "Leclerc": 3,
    "Hamilton": 4,
    "Pérez": 5,
    "Alonso": 6,
    "Norris": 7,
    "Sainz": 8,
    "Ocon": 9,
    "Stroll": 10,
    "Gasly": 11,
    "Albon": 12,
    "Schumacher": 13,
    "Vettel": 14,
    "Magnussen": 15,
    "Zhou": 16,
    "Ricciardo": 17,
    "Latifi": 18,
    "Bottas": 19,
    "Tsunoda": 20
  },
  {
    "season": "2022",
    "round": "16",
    "raceName": "Italian Grand Prix",
    "raceCode": "ITA",
    "date": "2022-09-11",
    "circuitName": "Autodromo Nazionale di Monza",
    "locality": "Monza",
    "country": "Italy",
    "Verstappen": 1,
    "Leclerc": 2,
    "Russell": 3,
    "Sainz": 4,
    "Hamilton": 5,
    "Pérez": 6,
    "Norris": 7,
    "Gasly": 8,
    "de Vries": 9,
    "Zhou": 10,
    "Ocon": 11,
    "Schumacher": 12,
    "Bottas": 13,
    "Tsunoda": 14,
    "Latifi": 15,
    "Magnussen": 16,
    "Ricciardo": 17,
    "Stroll": 18,
    "Alonso": 19,
    "Vettel": 20
  },
  {
    "season": "2022",
    "round": "17",
    "raceName": "Singapore Grand Prix",
    "raceCode": "SGP",
    "date": "2022-10-02",
    "circuitName": "Marina Bay Street Circuit",
    "locality": "Marina Bay",
    "country": "Singapore",
    "Pérez": 1,
    "Leclerc": 2,
    "Sainz": 3,
    "Norris": 4,
    "Ricciardo": 5,
    "Stroll": 6,
    "Verstappen": 7,
    "Vettel": 8,
    "Hamilton": 9,
    "Gasly": 10,
    "Bottas": 11,
    "Magnussen": 12,
    "Schumacher": 13,
    "Russell": 14,
    "Tsunoda": 15,
    "Ocon": 16,
    "Albon": 17,
    "Alonso": 18,
    "Latifi": 19,
    "Zhou": 20
  },
  {
    "season": "2022",
    "round": "18",
    "raceName": "Japanese Grand Prix",
    "raceCode": "JPN",
    "date": "2022-10-09",
    "circuitName": "Suzuka Circuit",
    "locality": "Suzuka",
    "country": "Japan",
    "Verstappen": 1,
    "Pérez": 2,
    "Leclerc": 3,
    "Ocon": 4,
    "Hamilton": 5,
    "Vettel": 6,
    "Alonso": 7,
    "Russell": 8,
    "Latifi": 9,
    "Norris": 10,
    "Ricciardo": 11,
    "Stroll": 12,
    "Tsunoda": 13,
    "Magnussen": 14,
    "Bottas": 15,
    "Zhou": 16,
    "Schumacher": 17,
    "Gasly": 18,
    "Sainz": 19,
    "Albon": 20
  }
]

export default data;